import React, { useState, useEffect } from 'react';
import { initializeApp, getApps, getApp } from 'firebase/app';
import {
  getAuth,
  initializeAuth,
  onAuthStateChanged,
  browserLocalPersistence,
  browserPopupRedirectResolver,
} from 'firebase/auth';
import { getDatabase, ref, get } from 'firebase/database';
import { FirebaseConfig } from '../config/FirebaseConfig';
import AdminLoginScreen from './AdminLoginScreen';

const RESTRICTED_MSG = {
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  height: '100vh',
  background: '#F0F2F5',
  fontFamily: 'Roboto, sans-serif',
  color: '#111B21',
};

function getFirebase() {
  if (!getApps().length) {
    const app = initializeApp(FirebaseConfig);
    const auth = initializeAuth(app, {
      persistence: browserLocalPersistence,
      popupRedirectResolver: browserPopupRedirectResolver,
    });
    return { app, auth };
  }
  const app = getApp();
  return { app, auth: getAuth(app) };
}

const ProtectionGate = ({ children }) => {
  // 'loading' | 'open' | 'login' | 'restricted'
  const [status, setStatus] = useState('loading');

  useEffect(() => {
    const { app, auth } = getFirebase();
    const db = getDatabase(app);

    get(ref(db, 'settings/enableWebProtectionLayer'))
      .then((snap) => {
        if (!snap.val()) {
          setStatus('open');
          return;
        }
        // Gate is ON — check current auth state
        const unsub = onAuthStateChanged(auth, async (user) => {
          unsub();
          if (!user) {
            setStatus('login');
            return;
          }
          try {
            const userSnap = await get(ref(db, `users/${user.uid}`));
            const u = userSnap.val();
            const ALLOWED = ['admin', 'fleetadmin', 'call_center_agent'];
            if (u && ALLOWED.includes(u.usertype)) {
              setStatus('open');
            } else {
              setStatus('login');
            }
          } catch {
            setStatus('login');
          }
        });
      })
      .catch(() => {
        setStatus('login');
      });
  }, []);

  if (status === 'loading') {
    return (
      <div style={{ ...RESTRICTED_MSG }}>
        <div style={{
          width: 40, height: 40, borderRadius: '50%',
          border: '4px solid #E9EDEF', borderTopColor: '#06113C',
          animation: 'spin 0.8s linear infinite',
        }} />
        <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
      </div>
    );
  }

  if (status === 'login') {
    return <AdminLoginScreen onSuccess={() => setStatus('open')} />;
  }

  return children;
};

export default ProtectionGate;
